import React, { SVGAttributes } from 'react';

/* A note when using this component - you will need to pass a fill color if you want anything other than black. */

const IconArrowDown = (props: SVGAttributes<SVGElement>) => (
  <svg viewBox="0 0 32 16" aria-hidden {...props}>
    <title>Arrow Down Icon</title>
    <path d="M17.92 14.79l12.812-9.896c.869-.627 1.29-1.631 1.097-2.62-.192-.988-.967-1.803-2.02-2.127-1.054-.324-2.22-.104-3.042.572l-10.83 8.367L5.108.72C4.286.043 3.12-.177 2.067.147 1.013.471.238 1.287.046 2.274c-.192.989.228 1.993 1.097 2.62l12.812 9.896a3.276 3.276 0 0 0 2.269.653 3.228 3.228 0 0 0 1.696-.653z" />
  </svg>
);

export default IconArrowDown;
